<!-- Copyright: Seán I. O'Donoghue -->
<!-- <Zoom v-if="item.stream && live" :id="item.stream" /> -->
<!-- <p v-else-if="item.description" class="description">
  {{ item.description }}
</p> -->

<template>
  <section>
    <div class="leftColumn">
      <!-- <p>{{ JSON.stringify(item, null, 2) }}</p> -->
      <!-- the speaker's highlight, in its dialog here (Seán, 2026-11-03: not the people page),
           as Video/Description.vue's; the address the fallback -->
      <a
        v-if="item.name && item.bio && !(item.names?.length > 1)"
        class="item"
        :href="`/${year}/People#${item.name.replaceAll(' ', '_')}`"
        @click.prevent="openSpeaker(item.name, null, year)">
        <Suspense>
          <img v-if="highlightImage" :src="highlightImage" />
          <!-- <img v-if="highlightImage" src="/2025/Hero.jpg" /> -->
          <!-- <img :src="useHighlightImage(item.name)" /> -->
          <!-- <img :src="useHighlightImage(item.name)" /> -->
          <!-- <PersonHeadshot :key="`${item.name}-headshot`" :person="item.name" /> -->
          <!-- <PersonHeadshot
            :person="item.name"
            :folder="`years/${year}/People/img/large`"
            :extension="'jpg'" /> -->
          <!-- @click="goToPerson(item.name)" -->
        </Suspense>
      </a>
      <!-- a session with no speaker image: the year's VIZBI letters, cut to 16:9 (2026-11-01) -->
      <!-- a shared session: its speakers' composite (no one highlight to open) -->
      <img v-else-if="item.names?.length > 1 && highlightImage" :src="highlightImage" alt="" />
      <img v-else src="/2026/Hero-trim.jpg" alt="" />
    </div>
    <div class="rightColumn">
      <!-- not sure if timeStamp is right format -->
      <!-- the date set in a line, as a fieldset's legend: the line through its middle, the text's
           top level with the image's top (Seán, 2026-11-03); a fieldset only for its look, so
           role none -->
      <fieldset class="dateLine" role="none">
        <legend>
          <time :datetime="item.startTimeStamp">
            {{ `${item.date}, ${item.start} - ${item.end}` }}
          </time>
        </legend>
      </fieldset>
      <!-- the title and speaker, centred in the space between the date (level with the image's
           top) and the countdown (level with its bottom). A breakout's kind above its topic, as
           metadata ("Breakout Q&A: Visual design" → BREAKOUT Q&A / Visual design); the title
           on one line, one size for every card: LiveEvent's, at which the longest fills the
           width exactly (Seán, 2026-11-03) -->
      <div class="middle">
        <p v-if="titleParts.category" class="category">{{ titleParts.category }}</p>
        <h4><span class="titleText" v-html="titleParts.title" /></h4>
        <!-- one line always: a breakout's three names smaller to fit (Seán, 2026-11-03: wrapped,
             the column outgrew the image, its top and bottom no longer level with it) -->
        <h5 ref="speakerRef" :style="speakerSize ? {fontSize: speakerSize} : undefined">
          {{ item.name }}
        </h5>
      </div>
      <div v-if="false">
        <p>title = {{ item.title }}</p>
        <p>waiting-room-open = {{ waitingRoomOpen }}</p>
        <p>live = {{ live }}</p>
        <p>ended = {{ ended }}</p>
        <p>name = {{ item.name }}</p>
      </div>
      <!-- the state, centred on a thin line over the countdown it labels (Seán, 2026-11-03: no
           dashes, no pill), the two read together, at the bottom; once ended, no countdown:
           the line level with the image's bottom, "Ended" standing on it (Seán, 2026-11-03) -->
      <div class="bottom" :class="{isEnded: ended && !live}">
      <fieldset class="divider" role="none">
        <legend>{{ live ? "Live now" : ended ? "Ended" : "Starts in" }}</legend>
      </fieldset>
      <!-- one slot, one height: the countdown until the start, then Join Meeting in its place,
           only on the first session live now (one button however many run in parallel) -->
      <div class="countdown">
        <!-- each side in an element of its own: a Transition needs one root, and Countdown's
             is several (2026-11-03: without it, the fade-out never ended, nor Join appeared) -->
        <Transition name="swap" mode="out-in">
          <div v-if="showCounter && !live" key="countdown">
            <Countdown
              :until="item.startTimeStamp"
              :highlight="count === 0"
              @hideCounter="showCounter = false" />
          </div>
          <div v-else-if="live && count === 0" key="join">
            <VideoLink :event-name="item.eventName" :is-check-in :is-opening />
          </div>
        </Transition>
      </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(`EventItem: ${msg}`); // eslint-disable-line
const props = defineProps({
  item: {default: () => ({})},
  count: {default: null},
  showLinkAt: {default: 15},
  isCheckIn: {type: Boolean, default: false}, // the event's check-in (Video/Link.vue)
  isOpening: {type: Boolean, default: false} // the first session after check-in (Video/Link.vue)
});
import {computed, nextTick, ref, onMounted, onBeforeUnmount, watch} from "vue";
import {useResizeObserver} from "@vueuse/core";
import {Interval} from "luxon";
import {getServerNow, isServerTimeKnown, startServerClock} from "@/composables/serverClock";
import Countdown from "@/components/Countdown.vue";
import VideoLink from "@/components/Video/Link.vue";
import useSpeakerDialog from "@/composables/useSpeakerDialog";
import history from "@/assets/history.json";
const year = history.latestYear;
const {openSpeaker} = useSpeakerDialog();

// the speaker line's size: the stylesheet's, or smaller, just enough for one line
const speakerRef = ref(null);
const speakerSize = ref("");
async function fitSpeaker() {
  const line = speakerRef.value;
  if (!line) return;
  speakerSize.value = "";
  await nextTick();
  if (line.scrollWidth <= line.clientWidth) return;
  const base = parseFloat(window.getComputedStyle(line).fontSize);
  speakerSize.value = `${Math.floor((base * line.clientWidth / line.scrollWidth) * 9.9) / 10}px`;
}
// again when its width changes, not its height (its own resize would set it off again)
let speakerWidth = 0;
useResizeObserver(speakerRef, ([entry]) => {
  const width = Math.round(entry.contentRect.width);
  if (width === speakerWidth) return;
  speakerWidth = width;
  fitSpeaker();
});
const emit = defineEmits(["ended"]);
// a breakout's: "Breakout Q&A: Visual design" → {category: "Breakout Q&A", title: "Visual
// design"}; any other title as it is
const titleParts = computed(() => {
  const title = String(props.item.title || "");
  const isBreakout = /^Breakout\b[^:]*:\s/.test(title);
  if (!isBreakout) return {category: "", title};
  const index = title.indexOf(":");
  return {category: title.slice(0, index), title: title.slice(index + 1).trim()};
});

const ended = ref(false);
const live = ref(false);
const waitingRoomOpen = ref(false);
const showCounter = ref(true);
const now = ref(getServerNow());
const tick = ref(null);
const highlightImage = ref(null);

// a shared session's speakers (LiveEvent.vue's names): their composite, "A+B+C.jpg" (made from
// their own images, the faces framed: 2026-11-03); one speaker, theirs
async function useHighlightImage(person) {
  const names = props.item.names?.length ? props.item.names : [person];
  const underscored = names.map((name) => String(name).replaceAll(" ", "_")).join("+");
  log(`person = ${person} → ${underscored}`);
  log(`year = ${year}`);
  try {
    highlightImage.value = require(`@/assets/years/${year}/People/img/large/${underscored}.jpg`);
    log(`found image at ${highlightImage.value}`);
  } catch (error) {
    log(`No large highlight image found for ${person}`);
  }
}

// nothing changes until the server's time is known: the link is never revealed by the
// visitor's own clock (serverClock.js)
watch(now, () => {
  if (ended.value || !isServerTimeKnown.value) return;
  if (now.value >= props.item.endTimeStamp) {
    if (!ended.value) log(`event has ended`); // print once only
    ended.value = true;
    live.value = false;
    emit("ended", props.item.startTimeStamp);
    return;
  }
  if (now.value >= props.item.startTimeStamp) {
    if (!live.value) log(`event has started`); // print once only
    if (!live.value) log(`startTimeStamp = ${props.item.startTimeStamp}`); // print once only
    if (!live.value) log(`endTimeStamp = ${props.item.endTimeStamp}`); // print once only
    live.value = true;
    waitingRoomOpen.value = false;
    return;
  }
  // log(`event is now within the waiting room`);
  const interval = Interval.fromDateTimes(now.value, props.item.startTimeStamp);
  if (interval.length("minutes") <= props.showLinkAt) {
    waitingRoomOpen.value = true;
  }
});

function startTimer() {
  return setInterval(() => {
    now.value = getServerNow();
  }, 100);
}

onMounted(async () => {
  startServerClock();
  tick.value = startTimer();
  await useHighlightImage(props?.item?.name);
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      console.log("tab now inactive - temporarily clear timer");
      clearInterval(tick.value);
    } else {
      console.log("tab is active again, so restarting timer");
      tick.value = startTimer();
    }
  });
});

onBeforeUnmount(() => {
  clearInterval(tick.value);
});
</script>

<style scoped>
section {
  display: flex;
  /* narrow (a phone): one column, date, title, speaker, then the image, then the countdown
     (Seán, 2026-11-03): the right column's parts placed around the image by order, 20px above
     and below it */
  flex-direction: column;
  gap: 0;
  padding: 20px; /* separates border from children */
  /* the columns the card's full width, stacked too (2026-11-03: centred, a one-line title set
     the text column's width and pushed a phone's page wider than its screen) */
  align-items: stretch;
  border-radius: 12px;
  /* a step off the page, in either theme (2026-11-01, Seán: the light card glared on the dark
     page): its text in the theme's colours, a level each (DESIGN.md § 4) */
  background-color: var(--background-color-subtle);
}
section > div.rightColumn {
  display: contents;
}
section > div.leftColumn {
  order: 2;
  margin-block: 20px; /* ▶ EDIT HERE: space above and below the image, on a phone */
}
div.rightColumn > fieldset.dateLine,
div.rightColumn > div.middle {
  order: 1;
}
div.rightColumn > div.bottom {
  order: 3;
}
.wide section,
.unlimited section {
  /* on wide screens, switch to rows; the columns as high as the image (the right one fills it:
     its date level with the image's top, its countdown with its bottom) */
  flex-direction: row;
  gap: 20px;
}
.wide section > div.rightColumn,
.unlimited section > div.rightColumn {
  display: flex;
}
.wide section > div.leftColumn,
.unlimited section > div.leftColumn {
  order: 0; /* side by side, the image first again, at the left (the phone's order undone) */
  margin-block: 0;
}
.wide div.countdown,
.unlimited div.countdown {
  min-height: var(--countdown-height, 58px);
}
.wide fieldset.divider,
.unlimited fieldset.divider {
  margin-bottom: 6px; /* ▶ EDIT HERE: space between the line and the countdown (side by side) */
}
section > * {
  /* selects direct children of section > left & right columns */
  /* https://stackoverflow.com/q/43739470 */
  flex: 1; /* give each child approximately equal height */
  min-width: 0; /* prevents from overflowing */
}
div.leftColumn {
  align-self: stretch; /* fill horizontal space */
  display: flex;
  align-items: center;
}
/* one group, centred against the image (Seán, 2026-11-03): the date (muted), the title (the
   brightest), the speaker (a step down), then the state's line and the countdown close under it */
div.rightColumn {
  display: flex;
  flex-direction: column; /* sets main axis as vertical */
  justify-content: space-between; /* the date at the top, the countdown at the bottom */
  align-items: stretch; /* fill horizontal space */
}

div.rightColumn > * {
  /* selects all direct children > parts of right column */
  flex: none;
  margin: 0px;
  padding: 0px;
  min-width: 0; /* prevents from overflowing */
}
/* the title and speaker, centred in the space between */
div.rightColumn > div.middle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px; /* ▶ EDIT HERE: between the title and the speaker */
  /* ▶ EDIT HERE: the title group sits a little lower in the space, nearer the countdown */
  padding-block: 12px 0;
}
.wide div.rightColumn > div.middle,
.unlimited div.rightColumn > div.middle {
  flex: 1;
}
time {
  display: block;
  font-size: 1.02rem;
  line-height: 1; /* its box the text, its top the image's (dateLine) */
  color: color-mix(in srgb, var(--text-color) 72%, transparent); /* secondary, as the speaker */
  text-align: center;
}
h4 {
  /* title: its size LiveEvent's (--title-size: the longest line across the sessions fills the
     width), else the stylesheet's; always two lines high, so every card's is the same */
  margin: 0;
  text-align: center;
  font-size: var(--title-size, 1.45rem);
  line-height: 1.25;
  min-height: 1.25em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; /* the title its own width, measured by the fit */
  /* its width the column's, never its one-line title's (2026-11-03: on a phone the title's
     full width counted in the page's minimum, widening it past the screen) */
  contain: inline-size;
  font-weight: 600;
  color: var(--text-color-strong);
}
/* an inline-block, centred in the h4; never wider than it (2026-11-03: on an iPhone, before
   the fit, a long title on one line widened the card past the screen), its full width still
   measured by the fit (scrollWidth: LiveEvent.vue) */
.titleText {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: var(--title-wrap, normal); /* nowrap in LiveEvent's list, the fit's one line */
}
/* the breakout's kind: metadata, as the date (Seán, 2026-11-03) */
p.category {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.06em;
  line-height: 1.3;
  text-transform: uppercase;
  text-align: center;
  color: color-mix(in srgb, var(--text-color) 65%, transparent);
}
h5 {
  /* name */
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  contain: inline-size; /* its width the column's, never its one line's (as the title's) */
  font-size: 1.2rem; /* global.css's 1.1rem, a tenth larger (Seán, 2026-11-03) */
  line-height: 1.3;
  color: color-mix(in srgb, var(--text-color) 72%, transparent); /* secondary, as the date */
  text-align: center;
  font-weight: 400;
}
/* a line with its text set in it: a fieldset's top border and its legend (Seán, 2026-11-03),
   the border drawn through the legend's middle; padding moves the line to the text's edge */
fieldset.dateLine,
fieldset.divider {
  margin: 0;
  padding: 0;
  min-inline-size: 0; /* a fieldset's default is its content's width */
  border: none;
  border-top: 1px solid color-mix(in srgb, var(--text-color) 22%, transparent);
}
fieldset.dateLine > legend,
fieldset.divider > legend {
  margin-inline: auto; /* centred on the line */
  padding: 0 12px; /* ▶ EDIT HERE: the gap between the text and the line either side */
}
/* the date: the line through the text's middle (the legend's own), the text's top level with
   the image's top (Seán, 2026-11-03): the legend's box is the text's 1em, the column's top */
fieldset.dateLine > legend {
  font-size: 1.02rem;
  line-height: 1;
}
/* "Starts in", "Live now": the line through the text's middle, over the countdown */
fieldset.divider {
  margin: 0 0 12px; /* ▶ EDIT HERE: space between the line and the countdown (a phone) */
  font-size: 0.9rem;
  color: color-mix(in srgb, var(--text-color) 50%, transparent); /* tertiary, as the units */
  text-align: center;
}
/* ended: no countdown; the line through the text's middle (as the date's), the text's bottom
   level with the image's bottom (Seán, 2026-11-03): the legend's box the text's 1em */
div.bottom.isEnded div.countdown {
  display: none;
}
div.bottom.isEnded fieldset.divider {
  margin-bottom: 0;
}
div.bottom.isEnded fieldset.divider > legend {
  line-height: 1;
}
p {
  /* description */
  text-align: left;
  text-decoration: none;
  font-size: 1.1rem;
  color: black;
  align-items: stretch; /* fill horizontal space */
}
div.countdown {
  min-width: 0;
  max-width: 100%;
  text-align: center;
  /* ▶ EDIT HERE: the countdown's height, kept when Join Meeting takes its place */
  /* a phone: its own height, nothing reserved (Seán, 2026-11-03); side by side, a fixed slot,
     so Join Meeting takes its place without a shift */
  display: flex;
  align-items: center;
  justify-content: center;
}
div.countdown > * {
  flex: 1;
}
/* https://stackoverflow.com/q */
img {
  /* max-width: 350px;
  min-width: 200px; */
  /* a soft dark shadow, not a light glow on the dark theme */
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.35));
  display: block;
  height: auto;
  width: 100%;
  object-fit: contain;
  object-position: center;
}
/* the countdown giving way to Join Meeting, in the same slot: a crossfade, nothing moves */
.swap-enter-active,
.swap-leave-active {
  transition: opacity 250ms ease;
}
.swap-enter-from,
.swap-leave-to {
  opacity: 0;
}
@media (prefers-reduced-motion: reduce) {
  .swap-enter-active,
  .swap-leave-active {
    transition: none;
  }
}
</style>
